import { LoqateSuggestion, LoqateAddress } from 'src/types/loqate';
import { wait } from './helpers';

export const isLoqateEnabled = env.APP_LOQATE_API_KEY && env.APP_LOQATE_API_KEY !== '';

export async function searchAddress(query: string, container?: string): Promise<LoqateSuggestion[]> {
  if (!isLoqateEnabled) {
    wait(500);
    return mockedResponse;
  }
  const apiKey = env.APP_LOQATE_API_KEY;
  const url =
    'https://api.addressy.com/capture/interactive/find/v1.1/json3.ws?' +
    `Key=${apiKey}` +
    `&Text=${query}` +
    `${container && container !== '' ? `&Container=${container}` : ''}` +
    `&IsMiddleware=true` +
    `&Field1Format={Latitude}` +
    `&Field2Format={Longitude}`;
  try {
    const response = await fetch(url, {
      headers: {
        'Content-Type': 'application/json',
      },
      referrer: window.location.origin,
      referrerPolicy: 'strict-origin-when-cross-origin',
    });
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    if (data.Items && data.Items.length > 0) {
      return data.Items;
    } else {
      return [];
    }
  } catch (error) {
    console.error('Error searching for address with Loqate:', error);
    return [];
  }
}

export async function getAddressById(id: string): Promise<LoqateAddress | null> {
  if (!isLoqateEnabled) {
    wait(500);
    return mockedAddress;
  }
  const apiKey = env.APP_LOQATE_API_KEY;
  const url =
    `https://api.addressy.com/capture/interactive/retrieve/v1.2/json3.ws?` +
    `Key=${apiKey}` +
    `&Id=${id}` +
    `&Field1Format={Latitude}` +
    `&Field2Format={Longitude}`;
  try {
    const response = await fetch(url, {
      headers: {
        'Content-Type': 'application/json',
      },
      referrer: window.location.origin,
      referrerPolicy: 'strict-origin-when-cross-origin',
    });
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    if (data.Items && data.Items.length > 0) {
      return data.Items[0];
    } else {
      return null;
    }
  } catch (error) {
    console.error('Error retrieving address by ID with Loqate:', error);
    return null;
  }
}

const mockedResponse = [
  {
    Id: 'RO|LP|A|3641079|18_RUM',
    Type: 'Address',
    Text: 'Mock Street 18',
    Highlight: '',
    Description: '335401 Mock Street',
  },
  {
    Id: 'RO|LP|A|3641080|19_RUM',
    Type: 'Address',
    Text: 'Mock Street 19',
    Highlight: '',
    Description: '335401 Mock Street',
  },
  {
    Id: 'RO|LP|A|3641081|20_RUM',
    Type: 'Address',
    Text: 'Mock Street 20',
    Highlight: '',
    Description: '335401 Mock Street',
  },
  {
    Id: 'RO|LP|A|3641082|21_RUM',
    Type: 'Address',
    Text: 'Mock Street 21',
    Highlight: '',
    Description: '335401 Mock Street',
  },
  {
    Id: 'RO|LP|A|3641083|22_RUM',
    Type: 'Address',
    Text: 'Mock Street 22',
    Highlight: '',
    Description: '335401 Mock Street',
  },
  {
    Id: 'RO|LP|A|3641084|23_RUM',
    Type: 'Address',
    Text: 'Mock Street 23',
    Highlight: '',
    Description: '335401 Mock Street',
  },
] as LoqateSuggestion[];
const mockedAddress = {
  Id: 'UK|LP|A|3641081|20_EN',
  DomesticId: '3641081',
  Language: 'EN',
  LanguageAlternatives: 'EN',
  Department: '',
  Company: '',
  SubBuilding: '',
  BuildingNumber: '20',
  BuildingName: '',
  SecondaryStreet: '',
  Street: 'Mock Street',
  Block: '',
  Neighbourhood: '',
  District: '',
  City: 'Mock Street',
  Line1: 'Mock Street 20',
  Line2: '',
  Line3: '',
  Line4: '',
  Line5: '',
  AdminAreaName: 'London',
  AdminAreaCode: '',
  Province: 'London',
  ProvinceName: 'London',
  ProvinceCode: 'HD',
  PostalCode: '335401',
  CountryName: 'United Kingdom',
  CountryIso2: 'UK',
  CountryIso3: 'UK',
  CountryIsoNumber: '642',
  SortingNumber1: '',
  SortingNumber2: '',
  Barcode: '',
  POBoxNumber: '',
  Label: 'Mock Street 20\n335401 Mock Street\nROMANIA',
  Type: 'Unknown',
  DataLevel: 'Premise',
  Field1: '23.27582',
  Field2: '45.9072',
  Field3: '',
  Field4: '',
  Field5: '',
  Field6: '',
  Field7: '',
  Field8: '',
  Field9: '',
  Field10: '',
  Field11: '',
  Field12: '',
  Field13: '',
  Field14: '',
  Field15: '',
  Field16: '',
  Field17: '',
  Field18: '',
  Field19: '',
  Field20: '',
};
